import React from 'react';
import {useHeader} from '../../../../_metronic/layout';
import {useIntl} from 'react-intl';
import SubheaderBar from '../../_common/components/SubheaderBar';
import NotificationsFilters from '../components/NotificationsFilters';
import NotificationsTable from '../components/NotificationsTable';
import {NotificationsProvider} from '../contexts/NotificationsContext';

const Notifications = () => {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: 'notifications-page-header',
    defaultMessage: 'Notifications page'
  }));

  return (
    <NotificationsProvider>
      <SubheaderBar>
        <NotificationsFilters/>
      </SubheaderBar>
      <NotificationsTable/>
    </NotificationsProvider>
  );
};

export default Notifications;
